export default {
  save: 'Enregistrer',
  confirm: 'Confirmer',
  cancel: 'Annuler',
  delete: 'Supprimer',
  complete: 'Terminer',
  loadingTip: 'En cours de chargement...',
  vanPagination: {
    prev: 'Précédent',
    next: 'Suivant',
  },
  vanPullRefresh: {
    pulling: 'Balayer vers le bas pour actualiser...',
    loosing: 'Drop to refresh...',
  },
};
